import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import DxDiagnosisListForm from '@src/features/tenant/dxDiagnosis/DxDiagnosisListForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function DxDiagnosisList() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.DX_DIAGNOSIS]}
    >
      <TenantDefaultLayout>
        <CommonHelmet />
        <DxDiagnosisListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default DxDiagnosisList;
